/** Glock 17, as a thing you can carry. The gun itself is `sim/weapons/guns/glock17.ts`. */

import { NO_ARMOR } from '@/sim/combat/armorMitigation';
import type { WeaponItem } from '@/sim/items/itemContract';

export const GLOCK17_ITEM = {
  id: 'glock17',
  kind: 'weapon',
  label: 'Glock 17',
  description:
    'Seventeen rounds of 9 mm and a polymer frame that outlived the department it was issued to.',
  rarity: 'common',
  weightKg: 0.9,
  stackLimit: 1,
  equip: {
    slots: ['sidearm', 'primaryWeapon'],
    statDeltas: {},
    armor: NO_ARMOR,
    damageModifiers: [],
  },
  weaponId: 'glock17',
} as const satisfies WeaponItem;
